import React, {useEffect, useState} from 'react';
import {Button, Card, Confirm, Form, Grid, Header, Icon, Loader, Modal, Progress, Segment} from "semantic-ui-react";
import ReactJWPlayer from 'react-jw-player';
import {Editor} from '@tinymce/tinymce-react';
import {useForm} from "react-hook-form";
import {
    postCourseSections,
    postTopicCreateVideo,
    postTopicSaveVideo,
    postTopicVideo,
    putCourseSections
} from "../../../../../redux/actions";

const VideoPlayer = ({item, saved, handleDeleteVideo}) => {
    const [loading, setLoading] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const video = item.video.media.key + '.' + item.video.extension;
    const base = 'https://cdn.jwplayer.com/videos/';
    const file = base + video;

    async function handleDelete() {
        setLoading(true);
        await handleDeleteVideo();
        setShowDelete(false);
        setLoading(false)
    }

    return <React.Fragment>
        <Confirm
            open={showDelete}
            header={'Atenção'}
            content={'Deseja realmente excluir este vídeo?'}
            cancelButton={<Button disabled={loading} content={'Fechar'}/>}
            confirmButton={<Button disabled={loading} loading={loading} negative content={'Sim, quero deletar!'}/>}
            onCancel={() => setShowDelete(false)}
            onConfirm={handleDelete}
            size={'tiny'}
        />
        <a
            href={'#'}
            onClick={() => setShowDelete(true)}
            style={{paddingBottom: 8, float: 'right', color: 'red'}}>
            Excluir vídeo
        </a>
        {/*{*/}
        {/*    (saved && saved.video) && <Message positive>*/}
        {/*        <Message.Header>Video enviado com sucesso!</Message.Header>*/}
        {/*        <p>O video pode demorar alguns minutos para ser renderizado.</p>*/}
        {/*    </Message>*/}
        {/*}*/}
        <ReactJWPlayer
            playerId='my-unique-id'
            playerScript='https://cdn.jwplayer.com/libraries/27MfXYK3.js'
            file={file}
        />
    </React.Fragment>
}

const VideoUpload = ({loadingVideoUpload, recent, videoProgress, handleUploadVideo}) => {
    return (
        <React.Fragment>
            {loadingVideoUpload &&
            <Progress percent={videoProgress} size='tiny' color='red' style={{marginBottom: 0}}/>}
            <Segment basic inverted textAlign={"center"} style={{
                minHeight: 180,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Header size={"tiny"} icon style={{marginBottom: 0}}>
                    {
                        (loadingVideoUpload || recent) ? (
                            <React.Fragment>
                                <Loader active={true} inline/><br />
                                {recent && 'Seu video esta sendo renderizado, aguarde.'}
                            </React.Fragment>
                            ) : (
                            <React.Fragment>
                                <input
                                    id='selectVideo'
                                    type={"file"}
                                    name={"file"}
                                    style={{display: 'none'}}
                                    accept={'video/*'}
                                    onChange={(e) => {
                                        const formData = new FormData();
                                        formData.append('file', e.target.files[0]);

                                        // noinspection JSIgnoredPromiseFromCall
                                        handleUploadVideo(formData);
                                    }}
                                />
                                <label htmlFor={'selectVideo'} style={{cursor: 'pointer'}}>
                                    <Icon name={"cloud upload"} style={{fontSize: '2em'}}/>
                                    <Header.Content>Enviar vídeo</Header.Content>
                                </label>
                            </React.Fragment>
                        )
                    }

                </Header>
            </Segment>
        </React.Fragment>
    )
}

export const TopicForm = ({show, item, onCancel, onSuccess}) => {
    const [loadingVideoUpload, setLoadingVideoUpload] = useState(false);
    const [videoProgress, setVideoProgress] = useState(0);
    const [recent, setRecent] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [saved, setSaved] = useState({});
    const [files, setFiles] = useState([]);

    const {register, handleSubmit, setValue, formState} = useForm({
        defaultValues: {
            title: item.title,
            article: item.article,
        }
    });

    useEffect(() => {
        setDeleted(false);
        setRecent(false);
        setSaved({});
    }, [show]);

    useEffect(() => {
        register('article');
    }, [register])

    const onSubmit = async data => {

        data.course_id = item.course_id;

        if (item.section_id) {
            data.parent_id = item.section_id;
        }

        try {
            const id = parseInt(data.id);
            if (id) {
                await putCourseSections(data);
            } else {
                await postCourseSections(data);
            }

            onSuccess();
        } catch (e) {
            alert('error')
        }
    };

    async function handleDeleteVideo() {
        try {
            await postTopicSaveVideo({id: item.id, video: {deleted: 1}});

            setDeleted(true)
            setSaved({});
            onSuccess(true)
        } catch (e) {

        }
    }

    async function handleUploadVideo(data) {

        const name = data.get('file')['name'];

        setLoadingVideoUpload(true);

        try {
            const res = await postTopicCreateVideo(item.id);
            const video = await postTopicVideo(res.data, data, setVideoProgress);

            video.data['name'] = name;

            const save = await postTopicSaveVideo({id: item.id, video: video.data});

            setDeleted(false);
            setSaved({video: save.data});
            setVideoProgress(0);
            setRecent(true)

            setTimeout(function(){
                setRecent(false);
            }, 60000);

            onSuccess(true);
        } catch (e) {
            console.log(e);
        } finally {
            setLoadingVideoUpload(false);
        }
    }

    return (
        <Modal open={show} size={'large'}>
            <Modal.Header>Editar Aula</Modal.Header>
            <Modal.Content style={{paddingBottom: 0}}>
                <Modal.Description>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={9}>
                                <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                                    <input type={'hidden'} name={'id'} defaultValue={item.id || ''} ref={register()}/>
                                    <Form.Field>
                                        <label>Título</label>
                                        <input
                                            name={'title'}
                                            defaultValue={item.title || ''}
                                            ref={register({required: true})}
                                            autoFocus
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        {/*<textarea*/}
                                        {/*    name={'article'}*/}
                                        {/*    defaultValue={item.article || ''}*/}
                                        {/*    ref={register}*/}
                                        {/*    rows={12}*/}
                                        {/*/>*/}
                                        <Editor
                                            initialValue={item.article || ''}
                                            apiKey='2k98j4xwwxemv13rlpv08fkevjw8nq5wjq44loezdszu39mq'
                                            init={{
                                                height: 330,
                                                menubar: false,
                                                plugins: [
                                                    'advlist autolink lists link image charmap print preview anchor',
                                                    'searchreplace visualblocks code fullscreen',
                                                    'insertdatetime media table paste code help wordcount'
                                                ],
                                                toolbar:
                                                    'undo redo | formatselect | bold italic backcolor | \
                                                    alignleft aligncenter alignright alignjustify | \
                                                    bullist numlist outdent indent | removeformat | help'
                                            }}
                                            onEditorChange={(text) => setValue('article', text)}
                                        />
                                    </Form.Field>
                                </Form>
                            </Grid.Column>
                            <Grid.Column width={7}>
                                {
                                    (!recent && !deleted && ((item.video && item.video.media) || saved.video))
                                        ? <VideoPlayer
                                            item={saved.video ? saved : item}
                                            saved={saved}
                                            handleDeleteVideo={handleDeleteVideo}
                                        />
                                        : <VideoUpload
                                            recent={recent}
                                            loadingVideoUpload={loadingVideoUpload}
                                            videoProgress={videoProgress}
                                            handleUploadVideo={handleUploadVideo}
                                        />
                                }
                                <Card fluid color={"red"}>
                                    <Card.Content>
                                        <Card.Header><Icon name={"file"}/> Arquivos ({files.length})</Card.Header>
                                    </Card.Content>
                                    <Card.Content>

                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    basic
                    content={'Cancelar'}
                    onClick={onCancel}
                    disabled={formState.isSubmitting || loadingVideoUpload}
                />
                <Button
                    positive
                    content="Salvar"
                    form={'form'}
                    disabled={formState.isSubmitting || loadingVideoUpload}
                    loading={formState.isSubmitting}
                />
            </Modal.Actions>
        </Modal>
    )
}